// Date and time utility functions
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  
  return `${parts[1]} ${parts[0]}, ${parts[2]}`;
};

export const parseExamDate = (dateStr) => {
  if (!dateStr) return null;
  
  // Try to parse using Date constructor
  const date = new Date(dateStr);
  
  // Check if it's a valid date
  if (isNaN(date.getTime())) {
    // If not, try parsing manually for formats like "May 19, 2025"
    const match = dateStr.match(/([A-Za-z]+)\s+(\d+),\s+(\d+)/);
    if (match) {
      const [ month, day, year] = match;
      const monthIndex = new Date(`${month} 1, 2000`).getMonth();
      return new Date(parseInt(year), monthIndex, parseInt(day));
    }
    return null;
  }
  
  return date;
};

export const isSameDay = (date1, date2) => {
  if (!date1 || !date2) return false;
  
  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
};

export const formatTime = (timeStr) => {
  if (!timeStr) return '';
  
  // Assume exam duration is 2 hours
  const hour = parseInt(timeStr.split(':')[0], 10);
  const minutes = timeStr.includes(':') ? timeStr.split(':')[1] : '00';
  
  const startHour = hour;
  const endHour = hour + 2;
  
  const period = hour < 12 ? 'AM' : 'PM';
  const endPeriod = endHour < 12 ? 'AM' : 'PM';
  
  const formattedStartHour = startHour > 12 ? startHour - 12 : startHour === 0 ? 12 : startHour;
  const formattedEndHour = endHour > 12 ? endHour - 12 : endHour === 0 ? 12 : endHour;
  
  return `${formattedStartHour}:${minutes} ${period} - ${formattedEndHour}:${minutes} ${endPeriod}`;
};